import { createContext, useContext, useEffect, useState } from "react";

const SlipContext = createContext(null);
const KEY = "parlaylab_slip";

export function SlipProvider({ children }) {
  const [legs, setLegs] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [wager, setWager] = useState(25);
  const [meta, setMeta] = useState(null);

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(legs)), [legs]);

  const has = (id) => legs.some((l) => l.pick_id === id);
  const toggle = (pick) => {
    setMeta(null);
    setLegs((prev) => (prev.some((l) => l.pick_id === pick.pick_id) ? prev.filter((l) => l.pick_id !== pick.pick_id) : [...prev, pick]));
  };
  const remove = (id) => setLegs((prev) => prev.filter((l) => l.pick_id !== id));
  const swap = (oldId, pick) => setLegs((prev) => prev.map((l) => (l.pick_id === oldId ? pick : l)));
  const replace = (picks, m = null) => {
    setLegs(picks);
    setMeta(m);
  };
  const clear = () => {
    setLegs([]);
    setMeta(null);
  };

  return <SlipContext.Provider value={{ legs, wager, setWager, has, toggle, remove, swap, replace, clear, meta }}>{children}</SlipContext.Provider>;
}

export const useSlip = () => useContext(SlipContext);
